const MediaListAutomatedTestIds = {
  MEDIA_LIST_DRAG_DROP_FILE_AREA: 'media-list-drag-drop-file-area',
  MEDIA_LIST_DRAG_DROP_UPLOAD_FILE: 'media-list-drag-drop-upload-file',
};

const VideoCoverImageTestIds = {
  VIDEO_UPLOAD_IMAGE: 'video-upload-image',
  VIDEO_SAVE_BUTTON: 'video-button-button',
};

export { MediaListAutomatedTestIds, VideoCoverImageTestIds };
